import React from 'react';
import { Box, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { apiSettingsCardSx } from '../../../constants/apiSettingsCardTypography';
import { useGetSftpSettingsHandler, useToggleSftpEnabledHandler } from '../dataHandlers/sftpSettingsHandlers';
import SftpConnectionCard from './SftpConnectionCard';
import SftpReceivedSection from './SftpReceivedSection';

const SftpIngestionCard = () => {
  const { enabled, isLoading } = useGetSftpSettingsHandler();
  const { onToggle, isPending: isTogglePending } = useToggleSftpEnabledHandler();

  return (
    <Box sx={apiSettingsCardSx.container}>
      <Stack spacing={1.5} alignItems="flex-start">
        <Typography sx={apiSettingsCardSx.title}>SFTP ingestion</Typography>
        <Typography variant="body2" color="text.secondary" sx={apiSettingsCardSx.description}>
          Exchange e-invoices over SFTP: drop ERP files into your org inbox for ingestion, and receive outbound/inbound
          archives back via SFTP. Turn Enable SFTP off to stop polling and archiving without deleting your
          configuration.
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={enabled}
              onChange={(e) => onToggle(e.target.checked)}
              disabled={isLoading || isTogglePending}
              color="primary"
            />
          }
          label="Enable SFTP"
          labelPlacement="end"
          sx={{ mr: 0, ml: 0 }}
        />
        {!enabled && !isLoading && (
          <Typography variant="body2" color="text.secondary">
            SFTP is off. Your configuration is kept but will not take effect until you enable it.
          </Typography>
        )}
      </Stack>

      {enabled && (
        <Box sx={{ mt: 2 }}>
          <SftpConnectionCard />
          <SftpReceivedSection />
        </Box>
      )}
    </Box>
  );
};

export default SftpIngestionCard;
